<template>
    <div :class="sidebarClass">
        <template v-if="$spa.getCurrentApp()">
            <div class="relative flex items-center justify-center px-5 pt-4 pb-3 lg:justify-start group">
                <img class="h-8 lg:mr-2" :src="$spa.getCurrentApp().icon" alt="Current app icon" v-if="displayAppIcon" />
                <span class="hidden text-lg lg:block text-slate-800">
                    {{ $spa.getCurrentApp().name }}
                </span>
                <div class="absolute right-0 items-center justify-center hidden w-6 h-6 -mr-3 text-xs bg-white border border-gray-200 rounded-full cursor-pointer hover:flex group-hover:flex hover:shadow text-slate-600 hover:text-slate-800" @click.prevent="$emit('hide')" v-if="displaySidebarToggle">
                    <i class="fas fa-chevron-left"></i>
                </div>
            </div>
            <v-spa-layout-sidebar-spacer></v-spa-layout-sidebar-spacer>
        </template>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            sidebarClass: {
                type: String,
            },
            displayAppIcon: {
                type: Boolean,
                default: true
            },
            displaySidebarToggle: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
